import styled from "styled-components";
import { DINGY_GRAY, NEAR_BLACK, NEAR_WHITE, LIGHT_GRAY } from "../../config";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  width: 100%;
  align-items: center;
  max-height: 36px;
  margin-right: 16px;

  .search-icon {
    position: absolute;
    color: ${DINGY_GRAY};
    left: 2rem;
  }

  input {
    padding-left: 3.5rem;
    border-radius: 6px;
  }
`;

export const Input = styled.input<{ background?: string }>`
  height: 36px;
  padding: 1rem;
  background: ${({ background }) => background ?? `${NEAR_BLACK}`};
  border: 1px solid ${NEAR_WHITE};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08);
  color: ${NEAR_WHITE};
  width: 100%;
  margin-bottom: 1px;
  outline: none;
  transition: 0.2s ease;
  font-size: 14px;

  &:focus {
    border-color: ${LIGHT_GRAY};
  }
`;

export const SearchButtonWrapper = styled.div`
  margin-left: 16px;
`;
